var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2229_24677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.27539 7C1.27539 3.13401 4.4094 0 8.27539 0H42.2754C46.1414 0 49.2754 3.13401 49.2754 7V41C49.2754 44.866 46.1414 48 42.2754 48H8.27539C4.4094 48 1.27539 44.866 1.27539 41V7Z",
    fill: "#F7D4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2754 26H27.2754V24H23.2754V26ZM23.2754 23H31.2754V21H23.2754V23ZM23.2754 20H31.2754V18H23.2754V20ZM21.2754 30C20.7254 30 20.2546 29.8042 19.8629 29.4125C19.4712 29.0208 19.2754 28.55 19.2754 28V16C19.2754 15.45 19.4712 14.9792 19.8629 14.5875C20.2546 14.1958 20.7254 14 21.2754 14H33.2754C33.8254 14 34.2962 14.1958 34.6879 14.5875C35.0796 14.9792 35.2754 15.45 35.2754 16V28C35.2754 28.55 35.0796 29.0208 34.6879 29.4125C34.2962 29.8042 33.8254 30 33.2754 30H21.2754ZM17.2754 34C16.7254 34 16.2546 33.8042 15.8629 33.4125C15.4712 33.0208 15.2754 32.55 15.2754 32V18H17.2754V32H31.2754V34H17.2754Z",
    fill: "#D32778"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2229_24677",
    x: 0.275391,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2229_24677"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2229_24677",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon);
export default __webpack_public_path__ + "static/media/education-icon.b3b52b5e0cd18e8cf823e993ad9ff023.svg";
export { ForwardRef as ReactComponent };